<script>
import FileUploadItem from './FileUploadItem.vue'
export default {
  components: {
    FileUploadItem
  },
  props: {
    filesInTransfer: { type: Object }
  },
  data() {
    return { hasError: false }
  },
  methods: {
    setError(event) {
      // if error is false and some error occured, update it
      if (!this.hasError && event) this.hasError = event
    },
    cancelAll() {
      this.filesInTransfer.files.forEach(file => file.cancelUpload())
    }
  }
}
</script>
<template>
  <v-dialog
    :value="filesInTransfer.inTransfer || hasError"
    transition="dialog-bottom-transition"
    elevation="0"
    persistent
    :width="$vuetify.breakpoint.mdAndDown ? '100%' : '500'"
  >
    <v-card light>
      <v-card-text class="text-center pt-2">
        <span>
          {{ $t('component.upload.fileUploadDialog.data.loading') }}<br />{{
            $t('global.patience.please')
          }}
        </span>
      </v-card-text>
      <v-card-text class="text-center pb-0">
        <v-progress-circular
          :rotate="90"
          :size="100"
          :width="15"
          :value="
            Math.round((filesInTransfer.actual / filesInTransfer.count) * 100)"
          color="primary">
          {{
            Math.round((filesInTransfer.actual / filesInTransfer.count) * 100)
          }}%
        </v-progress-circular>
      </v-card-text>
      <v-card-text>
        <v-row justify="center">
          <v-col cols="12">
            <v-list
              dense
              two-line
              class="pa-0 ma-0"
              max-height="35vh"
              style="overflow-y: auto">
              <template v-for="(file, index) in filesInTransfer.files">
                <FileUploadItem
                  :key="file.name + file.timestamp + index"
                  :file="file"
                  :uploaded="file.uploaded"
                  @update:hasError="setError($event)" />
              </template>
            </v-list>
          </v-col>
          <v-col align="end">
            <v-btn
              v-if="filesInTransfer.inTransfer"
              small
              color="error"
              @click="cancelAll"
            >{{ $t('button.cancel.uploads') }}</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
      <div v-if="hasError">
        <v-divider></v-divider>
        <v-card-text
        ><span class="error--text"
        ><v-icon color="error">mdi-close</v-icon
        >{{ $t('component.upload.fileUploadDialog.file.upload.errors') }}</span
        ></v-card-text>
        <v-divider></v-divider>
        <v-card-actions align="center">
          <v-spacer></v-spacer
          ><v-btn
          color="primary"
          :disabled="filesInTransfer.inTransfer"
          @click="hasError = false"
        >{{ $t('button.close') }}</v-btn
        ></v-card-actions>
      </div>
    </v-card>
  </v-dialog>
</template>
